import { render, staticRenderFns } from "./PatientChart.vue?vue&type=template&id=22760e6b&"
import script from "./PatientChart.vue?vue&type=script&lang=js&"
export * from "./PatientChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports